import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white pt-12 pb-20 px-6 lg:px-8" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-navy mb-8 transition-colors text-sm">
          <ArrowLeft size={16} /> Back to Home
        </Link>
        
        <h1 className="font-serif text-3xl md:text-4xl font-light text-navy mb-3">Privacy Policy</h1>
        <p className="text-slate-400 text-base mb-10">Last updated: September 2026 — written in plain English.</p>
        
        <div className="space-y-8 text-slate-600 text-base leading-[1.85]">
          <section>
            <h2 className="font-serif text-xl font-medium text-navy mb-3">Who we are</h2>
            <p>Third Culture Leadership is a leadership development practice founded by Dr Promise Monday. Our website is thirdcultureleadership.com. If you have questions about your data, email contact@thirdcultureleadership.co.uk.</p>
          </section>
          
          <section>
            <h2 className="font-serif text-xl font-medium text-navy mb-3">The CFQ assessment</h2>
            <p className="mb-3">The Cultural Fluency Quotient (CFQ) is a 20-question reflective tool. Here is exactly what happens with your data:</p>
            <ul className="space-y-2 ml-1">
              <li className="flex gap-2"><span className="text-[#C99316] mt-1.5">•</span> <span><strong>Your answers and scores</strong> are calculated in your browser and stored only on your device (localStorage). We never see them.</span></li>
              <li className="flex gap-2"><span className="text-[#C99316] mt-1.5">•</span> <span><strong>The anonymous pulse</strong> is optional. If you opt in after seeing your results, we store: today's date, any workshop session code, and your four pillar band labels (e.g. "Emerging"). We do not store your name, email, or individual question answers in this table.</span></li>
              <li className="flex gap-2"><span className="text-[#C99316] mt-1.5">•</span> <span><strong>The mailing list</strong> is separate from the pulse. If you subscribe, we store your email and first name. We never link your mailing-list record to your assessment results.</span></li>
              <li className="flex gap-2"><span className="text-[#C99316] mt-1.5">•</span> <span>The CFQ is <strong>not a psychometric test</strong>. It has not been independently validated. It is a reflective development tool and must not be used for hiring, selection, or performance evaluation.</span></li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-navy mb-3">What we collect elsewhere on the site</h2>
            <ul className="space-y-2 ml-1">
              <li className="flex gap-2"><span className="text-[#C99316] mt-1.5">•</span> <span><strong>Contact and enquiry forms</strong>: your name, email, organisation, and message. Used only to respond to your enquiry.</span></li>
              <li className="flex gap-2"><span className="text-[#C99316] mt-1.5">•</span> <span><strong>Newsletter</strong>: email and first name, with double opt-in. You can unsubscribe at any time.</span></li>
              <li className="flex gap-2"><span className="text-[#C99316] mt-1.5">•</span> <span><strong>Reader accounts</strong>: email and password (hashed). Used to access course materials and leave comments.</span></li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-navy mb-3">Cookies</h2>
            <p>We use essential cookies for login sessions and form protection. We do not use advertising or tracking cookies. No third-party analytics scripts run on this site without your consent.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-navy mb-3">Who sees your data</h2>
            <p>Your data is not sold to anyone. The site owner (Dr Promise Monday) can see aggregate CFQ completion counts and band distributions, enquiry messages, and mailing-list entries. The site owner cannot see individual CFQ answers or scores.</p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-navy mb-3">Your rights</h2>
            <p>You can request a copy of your data, ask us to delete it, or unsubscribe from emails at any time. Email contact@thirdcultureleadership.co.uk and we will respond within 30 days.</p>
          </section>

          {/* ISBN NOTE: PromondPublishing.jsx lists ISBN 978-1-918265-00-3. This should be verified for consistency across the site before going live. The privacy page does not reference ISBNs. */}

          <section>
            <h2 className="font-serif text-xl font-medium text-navy mb-3">Contact</h2>
            <p>Dr Promise Monday<br />Third Culture Leadership<br />contact@thirdcultureleadership.co.uk</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
